import { useSelector } from 'react-redux';

import { selectSellers } from './selectors';

export const useGetSellerById = ({ sellerId }: { sellerId?: string }) => {
  const sellers = useSelector(selectSellers);

  return sellers.find((seller) => seller.id === sellerId);
};
